export default "__VITE_ASSET__141c88c8__"